import { render } from "./CelebrationInfo.vue?vue&type=template&id=965e1fe8&scoped=true&lang=pug"
import script from "./CelebrationInfo.vue?vue&type=script&lang=js"
export * from "./CelebrationInfo.vue?vue&type=script&lang=js"

import "./CelebrationInfo.vue?vue&type=style&index=0&id=965e1fe8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965e1fe8"]])

export default __exports__